import { Button, Column, Icon, Row, Text } from "@amzn/meridian";
import React from "react";
import ResultDisplayCard from "src/components/UI/resultDisplayCard";
import { COLORS } from "src/constants/colors";
import {
  getInspectionsByUser,
  setDoneInspectingCurrentQuestion,
  setImageCapturingMode,
  setReadyToSubmitReport,
  updateInspection,
  updateInspectionResult,
} from "src/store/dataSlice";
import { useAppDispatch, useAppSelector } from "src/store/store";
import chevronLeftLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-left-large";
import { useNavigate } from "react-router-dom";
import { completedInspectionStatus } from "src/constants/constants";

const SubmitReport = () => {
  const {
    selectedInspectionTemplate,
    inspectionResults,
    currentCreatedInspection,
  } = useAppSelector((state) => state.data);
  const { alias } = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const submitReport = async () => {
    if (!selectedInspectionTemplate) return;
    try {
      for (const result of inspectionResults) {
        const resultToUpdate = new FormData();
        resultToUpdate.append("ai_result", result.aiResult);
        resultToUpdate.append("confirmed_result", result.confirmedResult);
        resultToUpdate.append("is_compliant", String(result.isCompliant));
        resultToUpdate.append(
          "is_inspector_override",
          String(result.isInspectorOverride)
        );
        if (result.overrideReason) {
          resultToUpdate.append("override_reason", result.overrideReason);
        }
        for (const evidence of result.evidences) {
          if (evidence?.file) resultToUpdate.append("files", evidence.file);
        }

        await dispatch(
          updateInspectionResult({
            inspection_id: currentCreatedInspection.inspectionId,
            question_id: result.questionId,
            formData: resultToUpdate,
          })
        ).unwrap();
      }
    } catch (error) {
      console.log(error);
    } finally {
      await dispatch(
        updateInspection({
          inspectionId: currentCreatedInspection.inspectionId,
          templateId: currentCreatedInspection.templateId,
          templateName: currentCreatedInspection.templateName,
          siteCode: currentCreatedInspection.siteCode,
          status: completedInspectionStatus,
          createdBy: currentCreatedInspection.createdBy,
          createdAt: currentCreatedInspection.createdAt,
        })
      );
      dispatch(getInspectionsByUser());
      navigate("/completedInspections");
    }
  };
  return (
    <Column
      className="questions-page"
      height="100vh"
      alignmentVertical="justify"
      backgroundColor={COLORS.DARKER_WHITE}
    >
      <Column>
        <Column
          width="100%"
          backgroundColor={COLORS.WHITE}
          spacingInset="600 500 400"
        >
          <Row>
            <div
              style={{ cursor: "pointer", marginLeft: "50px" }}
              onClick={() => {
                dispatch(setReadyToSubmitReport(false));
                dispatch(setDoneInspectingCurrentQuestion(false));
                dispatch(setImageCapturingMode(true));
              }}
            >
              <Icon tokens={chevronLeftLargeTokens} color="primary" />
            </div>
          </Row>
          <Column>
            <Row>
              {selectedInspectionTemplate?.templateName && (
                <Text type="b500">
                  {selectedInspectionTemplate?.templateName}
                </Text>
              )}
            </Row>
          </Column>
        </Column>
        <Column spacingInset="none 500">
          {inspectionResults.map((result, index) => {
            const currentQuestion = selectedInspectionTemplate?.questions.find(
              (question) => question.questionId === result.questionId
            );
            return currentQuestion?.questionText ? (
              <ResultDisplayCard
                questionText={currentQuestion?.questionText}
                evidenceUrl={result.evidences[0]?.fileUrl}
                questionIndex={index}
                isCompliant={result.isCompliant}
                isInspectorOverride={result.isInspectorOverride}
              />
            ) : (
              <></>
            );
          })}
        </Column>
      </Column>
      <Row spacingInset="500" widths={"fill"}>
        <Button
          type="tertiary"
          size="large"
          onClick={() => {
            dispatch(setReadyToSubmitReport(false));
            dispatch(setDoneInspectingCurrentQuestion(false));
            dispatch(setImageCapturingMode(true));
          }}
        >
          Back
        </Button>
        <Button
          disabled={
            inspectionResults.length !==
            selectedInspectionTemplate?.questions.length
          }
          size="large"
          onClick={submitReport}
        >
          Submit Report
        </Button>
      </Row>
    </Column>
  );
};

export default SubmitReport;
